import { initializeApp, getApps, getApp, FirebaseApp } from 'firebase/app';
import { environment } from '../../environments/environment';

let app: FirebaseApp;

export function getFirebaseApp(): FirebaseApp {
  if (!getApps().length) {
    app = initializeApp(environment.firebase);
  } else {
    app = getApp();
  }
  return app;
}
